import {css, StyleSheet} from 'aphrodite';
import classNames from 'classnames';
import React, {ReactNode} from 'react';

import {assertAndContinue} from 'Asserts';

interface ActionBarSkeletonProps {
  leftButtons: ReactNode;
  parameterList: ReactNode;
  rightButtons?: ReactNode;
}

/**
 * Action bar for dashboard editor or block editor
 *
 * Diagram:
 *   [left buttons] [parameter list]  [right buttons]
 *   (align left)                       (align right)
 *
 * Handles many parameters, wrapping them onto the next line.
 */
export default function ActionBarSkeleton(props: ActionBarSkeletonProps): JSX.Element | null {
  assertAndContinue(
    props.leftButtons != null || props.parameterList != null || props.rightButtons != null,
    'Expected action bar to have contents'
  );
  return (
    <div className={classNames(css(styles.actionBarContainer), 'u-small-spacing-top')}>
      <span>
        <span className={css(styles.leftButtons)}>{props.leftButtons}</span>
        {props.parameterList}
      </span>
      {props.rightButtons && <div className="u-mini-spacing-left u-no-wrap">{props.rightButtons}</div>}
    </div>
  );
}

const styles = StyleSheet.create({
  actionBarContainer: {
    // Align items to top
    alignItems: 'center',
    display: 'flex',
    // Align leftContent to left, align rightButtons to right
    justifyContent: 'space-between',
  },
  leftButtons: {
    ':nth-child(1n) > *': {
      marginRight: 16,
    },
  },
});
